import { ReferenceDataDto } from '../../generated/auth/models/Sasfin/Dynamics/Api/Client/Models/DTO/reference-data-dto';

export interface IOccupationState {
  list: ReferenceDataDto[];
  isLoading: boolean;
}

export const initialUIState: IOccupationState = {
  list: [],
  isLoading: false,
};
